import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=e8429970&scoped=true"
var script = {}
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=e8429970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8429970",
  null
  
)

export default component.exports